import React, { useContext, useState } from 'react';
import { AddSaveContactDto, ContactDto } from '../../../types';
import CustomInput from '../../global-components/customInput';
import { isValidEmail, isValidationValidated } from '../../../utils/helper';
import { AddContactInitialValues } from '../../../initial-values';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';
import { addSavedContact } from '../../../api/privateApis';
import SaveContactModal from './saveContactModal';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
import { AbilityContext } from '../../../context/AbilityContext';
interface Props {
  formData: ContactDto;
  setFormData: React.Dispatch<React.SetStateAction<ContactDto>>;
  validating: boolean;
  formValidation: any;
  setFormValidations: any;
  title?: any;
}
function ContactForm({
  formData,
  setFormData,
  validating,
  formValidation,
  setFormValidations,
  title,
}: Props) {
  const userData = useSelector(
    (state: RootState) => state.mainAppData.userData
  );
  const isVendor = userData?.is_vendor;
  const location = useLocation();
  const isManualShipment = location?.pathname === '/app/admin/manual-shipments';
  const ability = useContext(AbilityContext);
  const { enqueueSnackbar } = useSnackbar();
  const [saveContact, setSaveContact] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSavedContactModal, setShowSavedContactModal] = useState(false);
  const [savedContactForm, setSavedContactForm] = useState<AddSaveContactDto>(
    AddContactInitialValues
  );
  function savedContactFunc() {
    if (isValidationValidated(formValidation)) {
      setShowSavedContactModal(true);
      setSavedContactForm({
        ...savedContactForm,
        contact: formData,
        username: userData?.username,
        account_number: userData?.account_number,
      });
    } else {
      enqueueSnackbar('Please fill all the fields.', { variant: 'error' });
      setSaveContact(false);
    }
  }
  function onSave() {
    setLoading(true);
    addSavedContact(savedContactForm)
      .then((response) => {
        if (!response?.data?.is_error) {
          setLoading(false);
          setShowSavedContactModal(false);
          enqueueSnackbar('Contact has been added', { variant: 'success' });
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  }
  return (
    <div className={`${isVendor ? 'mt-3' : ''}`}>
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}

      <CustomInput
        id={'company_name'}
        className='form-control ubbe-input'
        label={'Company'}
        type={'text'}
        placeholder={'Company Name'}
        required
        error={'Please provide a valid company name.'}
        value={formData.company_name}
        maxLength={30}
        // isVendor={isVendor}
        isDisabled={isVendor}
        validating={validating}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setFormValidations({
            ...formValidation,
            company_name: e.target.value !== '',
          });
          setFormData({
            ...formData,
            company_name: e.target.value,
          });
        }}
      />

      <CustomInput
        id={'name'}
        className='form-control ubbe-input'
        label={'Name'}
        type={'text'}
        placeholder={'Full Name'}
        required
        error={'Please provide a valid name.'}
        value={formData.name}
        validating={validating}
        maxLength={30}
        isDisabled={isVendor}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setFormValidations({
            ...formValidation,
            name: e.target.value !== '',
          });
          setFormData({
            ...formData,
            name: e.target.value,
          });
        }}
      />
      <CustomInput
        id={'phone'}
        className='form-control ubbe-input'
        label={'Phone'}
        type={'text'}
        placeholder={'1112223333'}
        required
        error={'Please provide a valid phone number.'}
        value={formData.phone}
        validating={validating}
        minLength={10}
        maxLength={15}
        isDisabled={isVendor}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setFormValidations({
            ...formValidation,
            phone: e.target.value.length > 9,
          });
          setFormData({
            ...formData,
            phone: e.target.value.replace(/[^0-9]/g, ''),
          });
        }}
      />
      <CustomInput
        id={'email'}
        className='form-control ubbe-input'
        label={'Email'}
        type={'email'}
        placeholder={'email@gmail.com'}
        required
        error={'Please provide a valid email.'}
        value={formData.email}
        validating={validating}
        maxLength={100}
        isDisabled={isVendor}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setFormValidations({
            ...formValidation,
            email: e.target.value !== '' && isValidEmail(e.target.value),
          });
          setFormData({
            ...formData,
            email: e.target.value,
          });
        }}
      />
      <div className='d-flex row mt-4'>
        <div className=''>
          {ability?.can('create', 'Saved Contact') && (
            <div className='d-flex gap-2 align-items-center justify-content-center'>
              <input
                className='form-check-input mt-0'
                type='checkbox'
                checked={saveContact}
                id='save_contact'
                onChange={(e) => {
                  setSaveContact(e.target.checked);
                  if (e.target.checked) {
                    savedContactFunc();
                  }
                }}
              />
              <label
                className='form-check-label'
                htmlFor='origin_save_address_checkbox'
              >
                {title ? title + '?' : ' Save Contact?'}
              </label>
            </div>
          )}
        </div>
      </div>
      {showSavedContactModal && (
        <SaveContactModal
          onClose={() => {
            setShowSavedContactModal(false);
            setSaveContact(false);
          }}
          savedContactForm={savedContactForm}
          setSavedContactForm={setSavedContactForm}
          onSave={onSave}
          title={title}
        />
      )}
    </div>
  );
}

export default ContactForm;
